export const Translations_en = {
    HoşGeldiniz:"Welcome to login page",
    userlogin: "User Login",
    loginbtn: "Login",
    password: "Password",
    logoutbtn : "Logout",
    headertitle: "Customer License View Portal",
    headerwelcome: "Welcome",
    licensetabletitle: "My Licenses Information",
    productname: "Product Name",
    licensekey: "License Key",
    startdate: "Starting Date",
    enddate: "End Date",
    cardtitle: "Update your License and Software",
    cardtext: "Only license packages associated with your product can be installed.",
    cardbtn: "Download your license",
    licensetabletitle2: "License Usage Information",
    offlineUpdatePackages: "Offline Update Packages",
   };